import { render, staticRenderFns } from "./login-password.vue?vue&type=template&id=7a1c6106&scoped=true&"
import script from "./login-password.vue?vue&type=script&lang=js&"
export * from "./login-password.vue?vue&type=script&lang=js&"
import style0 from "./login-password.vue?vue&type=style&index=0&id=7a1c6106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1c6106",
  null
  
)

export default component.exports